import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { ProductContext } from '../../App';
import RoleComponent from '../../components/authentications/RoleComponent';
import EditSell from '../../components/popups/EditSell';
import Exchange from '../../components/popups/Exchange';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ChangeCircleSharpIcon from '@mui/icons-material/ChangeCircleSharp';
import CancelIcon from '@mui/icons-material/Cancel';

function OrderTable(props) {
    const product_context = useContext(ProductContext);
    const { confirmDialogue, setConfirmDialogue, setIsLoading, alert, setAlert } = product_context;

    const [editSell, setEditSell] = useState({ isOpen: false })

    const [exchangeSell, setExchangeSell] = useState({ isOpen: false });

    const [sort, setSort] = useState();
    const [orderDetails, setOrderDetails] = useState();
    const [grandTotal, setGrandTotal] = useState(0);
    const [grandTotalReceived, setGrandTotalReceived] = useState(0);
    const [dates, setDates] = useState({
        orders_year_list: [],
        orders_month_list: [],
    });

    const monthInString = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    useEffect(() => {
        let orderdetails = props.soldDataSearchById ? props.orderDetails.filter(el => el._id === props.soldDataSearchById) : props.orderDetails;
        orderdetails = orderdetails.sort((p1, p2) => {
            return new Date(p2.order_date) - new Date(p1.order_date);
        })
        setDates({
            orders_year_list: [...new Set(orderdetails.map(el => el.year))],
            orders_month_list: [...new Set(orderdetails.map(el => el.month))]
        });
    }, [props.orderDetails, props.soldDataSearchById]);

    useEffect(() => {
        setSort({
            year: dates.orders_year_list[0],
            month: dates.orders_month_list[0],
        })
    }, [dates]);

    useEffect(() => {
        const orderdetails = props.soldDataSearchById ? props.orderDetails.filter(el => el._id === props.soldDataSearchById) : props.orderDetails;
        let orderDetails = sort ? orderdetails.filter(el => el.year === sort?.year && el.month === sort?.month) : orderdetails;
        let grand_total = 0;
        orderDetails.forEach(order => {
            if (order?.total_price) {
                grand_total += order?.total_price;
            }
        })
        let paymentReceivedOrders = orderDetails.filter(d => d.payment === 'Received');
        let grand_total_received = 0;
        paymentReceivedOrders.forEach(order => {
            if (order?.total_price) {
                grand_total_received += order?.total_price;
            }
        })
        setGrandTotalReceived(grand_total_received);
        setGrandTotal(grand_total);
        setOrderDetails(orderDetails)
    }, [sort, props.orderDetails, props.soldDataSearchById]);


    const handleDeleteOrder = (order) => {
        setIsLoading(true);
        let data = {
            order: order,
        }
        axios.put(`${process.env.REACT_APP_SERVER_DOMAIN}/sell/remove/${order._id}`, data)
            .then(res => {
                setAlert({
                    isOpen: true,
                    message: "Successfull",
                    type: "success",
                })
                setIsLoading(false);
                props.setChangeSellsState(!props.changeSellsState);
            })
            .catch(err => {
                setAlert({
                    isOpen: true,
                    message: "Something Went Wrong",
                    type: "danger",
                })
                setIsLoading(false);
            })
        setTimeout(() => {
            setAlert({ ...alert, isOpen: false });
        }, 5000);
        setConfirmDialogue({ ...confirmDialogue, isOpen: false });
    }

    const handleEditOrder = (order) => {
        document.body.classList.add('remove-scroll');
        setEditSell({
            isOpen: true,
            order: order,
        })
    }

    const handleReturn = (order) => {
        setConfirmDialogue({
            isOpen: true,
            message: 'Do you want to Return this Order?',
            submitHandle: () => { actualReturn(order) }
        })
    }

    const actualReturn = (order) => {
        setIsLoading(true);
        let data = {
            status: 'returned',
            order: order,
        }
        axios.put(`${process.env.REACT_APP_SERVER_DOMAIN}/sell/${order._id}`, data)
            .then(res => {
                setAlert({
                    isOpen: true,
                    message: "Successfull",
                    type: "success",
                })
                setIsLoading(false);
                props.setChangeSellsState(!props.changeSellsState);
            })
            .catch(err => {
                setAlert({
                    isOpen: true,
                    message: "Something Went Wrong",
                    type: "danger",
                })
                setIsLoading(false);
            })
        setTimeout(() => {
            setAlert({ ...alert, isOpen: false });
        }, 5000);
        setConfirmDialogue({ ...confirmDialogue, isOpen: false });
    }

    return (
        <div>
            <Exchange exchangeSell={exchangeSell} setExchangeSell={setExchangeSell} setIsLoading={setIsLoading} setChangeSellsState={props.setChangeSellsState} changeSellsState={props.changeSellsState} />
            <EditSell editSell={editSell} setEditSell={setEditSell} setIsLoading={setIsLoading} setChangeSellsState={props.setChangeSellsState} changeSellsState={props.changeSellsState} />

            <div className="sorting">
                <h3 className="text-center">Orders Table</h3>
                <select onChange={(e) => { setSort({ ...sort, year: Number(e.target.value) }) }} className="form-select sort" name='year'>
                    {dates.orders_year_list?.map((year, i) => {
                        return year === sort?.year ? <option selected key={i} defaultValue={year}>{year}</option> : <option key={i} value={year}>{year}</option>
                    })}
                </select>
                <select onChange={(e) => { setSort({ ...sort, month: Number(e.target.value) }) }} className="form-select sort" name='year'>
                    {dates.orders_month_list?.map((month, i) => {
                        return month === sort?.month ? <option selected key={i} defaultValue={month}>{monthInString[month - 1]}</option> : <option key={i} value={month}>{monthInString[month - 1]}</option>
                    })}
                </select>
            </div>

            <div className="d-flex align-items-center justify-content-center">
                <div className="stock-table">
                    <table className='table-bordered'>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Instagram ID</th>
                                <th>Item Details</th>
                                <th className='phone'>Actions</th>
                                <th>Price</th>
                                <th>Address</th>
                                <th>Contact</th>
                                <th>Order Date</th>
                                <th>Delivered Date</th>
                                <th>Status</th>
                                <th>Delivery Charge</th>
                                <th>Total</th>
                                <th>Payment Method</th>
                                <th>Courier Partner</th>
                                <th>Courier Code</th>
                                <th>Delivery Instructions</th>
                                <th>Options</th>
                                <th className='desktop'>Actions</th>
                                <th>Payment</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderDetails?.length !== 0 ? null : <tr><td className='text-danger' colSpan={15}>No Details Found</td></tr>}
                            {orderDetails?.map((order, i) => {
                                let item_details = order?.product_details?.item_type + '-' + order?.product_details?.item_name + '-' + order?.color + '-' + order?.size;

                                let date = order?.order_date;
                                let formated_date = date?.split('T');
                                let delivery_date = order?.delivery_date || '';
                                let formated_delivery_date = delivery_date.split('T');
                                return <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{order?.customer_details?.name || '-'}</td>
                                    <td>{order?.customer_details?.instagram_id || '-'}</td>
                                    <td>{item_details || '-'}</td>
                                    <td className='action phone'>
                                        <EditIcon onClick={() => { handleEditOrder(order) }} className="fa-solid fa-file-pen mx-3 edit"></EditIcon>
                                        <RoleComponent role='admin'>
                                            <DeleteIcon onClick={() => {
                                                setConfirmDialogue({
                                                    isOpen: true,
                                                    message: 'Do you want to Delete this Order?',
                                                    submitHandle: () => { handleDeleteOrder(order) }
                                                });
                                                document.body.classList.add('remove-scroll');
                                            }} className="fa-solid fa-trash delete mx-3"></DeleteIcon>
                                        </RoleComponent>
                                    </td>
                                    <td>{order?.price || '-'}</td>
                                    <td>{order?.customer_details?.address || '-'}</td>
                                    <td><a href={`tel:${order?.customer_details?.contact_number}`}>{order?.customer_details?.contact_number || '-'}</a></td>
                                    <td>{formated_date[0]}</td>
                                    <td>{formated_delivery_date[0] || '-'}</td>
                                    <td className={`${order?.status === 'done' ? 'bg-success' : ''}${order?.status === 'canceled' || order?.status === 'returned' || order?.status === 'exchanged/received' || order?.status === 'returned/received' ? 'bg-danger' : order?.status === 'exchanged' ? 'bg-warning' : ''}`}>{order?.status || '-'}</td>
                                    <td>{order?.delivery_charge || '-'}</td>
                                    <td>{order?.total_price || '-'}</td>
                                    <td>{order?.payment_method || '-'}</td>
                                    <td>{order?.courier_partner || '-'}</td>
                                    <td>{order.courier_partner === 'NCM' ? <a rel="noreferrer" href={`https://portal.nepalcanmove.com/accounts/vendor/order/${order.courier_code}`} target={'_blank'}>{order.courier_code || '-'}</a> : order.courier_partner === 'Buddha Courier' ? <a rel="noreferrer" href={`https://buddhacouriers.com.np/tracking?bill_no=${order.courier_code}`} target={'_blank'}>{order.courier_code || '-'}</a> : order.courier_code || '-'}</td>
                                    <td>{order?.delivery_instructions || '-'}</td>
                                    <td>
                                        {order?.status === 'done' ? <div className='action'>
                                            <ChangeCircleSharpIcon onClick={() => {
                                                setExchangeSell({
                                                    isOpen: true,
                                                    order: order,
                                                })
                                                document.body.classList.add('remove-scroll');
                                            }} className="fa-solid fa-recycle mx-3 edit" title='Exchange'></ChangeCircleSharpIcon>
                                            <CancelIcon onClick={() => { handleReturn(order) }} title='Return' className="fa-solid fa-nfc-slash delete mx-3"></CancelIcon>
                                        </div> : '-'}
                                    </td>
                                    <td className='action desktop'>
                                        <EditIcon onClick={() => { handleEditOrder(order) }} className="fa-solid fa-file-pen mx-3 edit"></EditIcon>
                                        <RoleComponent role='admin'>
                                            <DeleteIcon onClick={() => {
                                                setConfirmDialogue({
                                                    isOpen: true,
                                                    message: 'Do you want to Delete this Order?',
                                                    submitHandle: () => { handleDeleteOrder(order) }
                                                });
                                                document.body.classList.add('remove-scroll');
                                            }} className="fa-solid fa-trash delete mx-3"></DeleteIcon>
                                        </RoleComponent>
                                    </td>
                                    <td>{order?.payment || '-'}</td>
                                </tr>
                            })}
                            <tr className='bcg-danger'>
                                <td colSpan={9}>Grand Total : {grandTotal}</td>
                                <td colSpan={10}>Grand Total Received: {grandTotalReceived}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default OrderTable
